import hooks from './shipment-etas.hooks';
import createSchema from './shipment-etas.schema';

export default (app) => {
  const service = app.service('api/shipment-etas');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
